import { render, staticRenderFns } from "./FAccordion.vue?vue&type=template&id=1cfc846f&"
import script from "./FAccordion.vue?vue&type=script&lang=js&"
export * from "./FAccordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports